import React , { Component, Fragment } from 'react'
import { Route, Switch } from "react-router-dom"
import { withTranslation } from 'react-i18next';
import SSoPage from './SsoPage';

class SsoRouter extends Component {

  render() {
    const { location } = this.props

    return (
      <Fragment>
        <Switch location={location}>
          <Route component={SSoPage}/>
        </Switch>
      </Fragment>
    )
  }
}

export default withTranslation()(SsoRouter)